<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://', v-if='params')
            template(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='false',
                            :options='tableModes',
                            :show-labels='false',
                            :allow-empty='false',
                            track-by='mode',
                            label='name',
                            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                            v-model='selectedTableMode',
                            @select='selectTablesAmount($event.mode)'
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_redAndBlack') }}
                    .form__field-body
                        cs-checkbox(
                            v-model='params.redAndBlack',
                            @change="handleSelectOfColoredMode",
                            :disabled="selectedGameMode.mode === 'mixed'"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_tenth') }}
                    .form__field-body
                        cs-checkbox(
                            v-model='params.tenth',
                            @change="handleSelectOfTenthMode",
                        )
                .form__field(v-if="isMentalArithmeticGame")
                    label.form__label
                        | {{ $i18n.t('common.common_gameName_flashCards') }}
                    .form__field-body
                        cs-checkbox(
                            v-model='params.flashCards',
                            @change="handleSelectOfFlashCardsMode",
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='false',
                            :options="difficulties"
                            v-model='params.difficult',
                            :custom-label="difficultLabel"
                            :placeholder="difficultLabel(params.difficult)"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                    .form__field-body.form-container__select-examples
                        cs-spin-input(
                            :value="params.numOfExamples",
                            :max="numOfExamples",
                            :min="1",
                            @increase="increaseExamples",
                            @decrease="decreaseExamples",
                            @input="params.numOfExamples = $event",
                            :disabled="params && params.infinityAmountOfExamples"
                        )
                        .form-container__select-infinity-mode(v-if="isInfinityAmountAvailable")
                            cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                                v-model="params.infinityAmountOfExamples"
                                :checked="params && params.infinityAmountOfExamples"
                            )
                            svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_order') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='false',
                            :options='gameModesOptions',
                            :show-labels='false',
                            :allow-empty='false',
                            track-by='mode',
                            label='name',
                            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseGameWithTime')",
                            v-model='selectedGameMode',
                            @select='params.mode = $event.mode'
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_invertedTable') }}
                    .form__field-body
                        cs-checkbox(v-model="params.invertedTable")
                divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame')
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import _ from "lodash";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                gameModes: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_direct'),
                        mode: 'direct'
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_reverse'),
                        mode: 'reverse'
                    },
                    {
                        name: this.$i18n.tc('trainer.trainer_gameFormSettingValue_mixed', 1),
                        mode: 'mixed'
                    }
                ],
                tableModes: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_oneTable'),
                        mode: 1,
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_twoTables'),
                        mode: 2,
                    }
                ],
                difficulties: [3, 4, 5, 6, 7, 8],
                numOfExamples: 15,
                selectedGameMode: null,
                selectedDifficult: null,
                params: null,
                selectedTableMode: null,
            }
        },
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find((item) => {
                        return item.slug === this.slug
                                && item.courseType === (this.isMentalArithmeticGame ? 'mental-arithmetic' : 'fast-reading')
                    }).parameters.default;
                }
                this.isMentalArithmeticGame && (this.params.infinityAmountOfExamples = true);
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedGameMode = _.find(this.gameModes, { mode: this.params.mode });
            this.selectedDifficult = this.params.difficult;
            this.selectedTableMode = this.tableModes.find(mode => mode.mode === this.params.amountOfTables);
        },
        updated () {
            this.selectedGameMode = _.find(this.gameModes, { mode: this.params.mode });
            this.selectedDifficult = this.params.difficult;
            this.gameModes.find(item => item.mode === 'mixed').$isDisabled = this.params.redAndBlack;
        },
        methods: {
            selectTablesAmount (number) {
                this.params.amountOfTables = number;
                if (number === 1) {
                    this.selectedGameMode = this.gameModes[0];
                    this.params.mode = this.selectedGameMode.mode;
                }
            },
            handleSelectOfColoredMode () {
                this.$nextTick(() => {
                    if (this.selectedGameMode.mode === 'mixed') {
                        this.selectedGameMode = this.gameModes[0];
                        this.params.mode = this.selectedGameMode.mode;
                    }
                    this.params.flashCards = false;
                    this.gameModes.find(item => item.mode === 'mixed').$isDisabled = this.params.redAndBlack;
                })
            },
            handleSelectOfFlashCardsMode () {
                this.$nextTick(() => {
                    this.params.redAndBlack = false;
                    this.params.tenth = false;
                })
            },
            handleSelectOfTenthMode () {
                this.$nextTick(() => {
                    this.params.flashCards = false;
                })
            },
            difficultLabel (difficult) {
                return difficult + ' x ' + difficult;
            },
            decreaseExamples () {
                if (this.params.numOfExamples !== 1 && !this.params.infinityAmountOfExamples) {
                    this.params.numOfExamples -= 1;
                }
            },
            increaseExamples () {
                if (this.params.numOfExamples !== this.numOfExamples && !this.params.infinityAmountOfExamples) {
                    this.params.numOfExamples += 1;
                }
            },
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
            gameModesOptions () {
                if (this.selectedTableMode && this.selectedTableMode.mode === 1) {
                    return this.gameModes.slice(0, 2);
                }
                return this.gameModes;
            },
            isMentalArithmeticGame () {
                return this.courseType === 'mentalArithmetic';
            },
            isInfinityAmountAvailable () {
                return this.gameMode && this.gameMode === 'free-game' && this.isMentalArithmeticGame;
            },
            disabledRedAndBlackCheckbox() {
                return this.selectedGameMode.mode === 'mixed' ? 'disable-checkbox' : false;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__field--column {
        flex-direction: column;
        margin-bottom: 20px;
        align-items: flex-start;
    }

    .form__input {
        margin-bottom: 0;
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__label--left {
        min-width: 0;
        width: auto;
        margin-bottom: 20px;
    }

    .form__label--image {
        @include media($md) {
            padding-top: 2.5em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--inline {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .form__field-body--bold {
        font-weight: 500;
    }

    .numbers-checkbox:not(:last-child) {
        margin-right: 10px;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }

    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }

    .form-container__checkbox{
        margin-left: 30px;
    }

    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }
</style>
